// extracted by mini-css-extract-plugin
export var textInput = "_lx-0";